import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  StyledTable,
  PlanTableRow
} from 'modules';
import * as ds from './dataService';

export type PlanTableProps = {
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanTableProps) => {
  const params = useParams();

  const { data } = ds.useQuery(params.projectId ?? '', params.planSetId);

  const headers: string[] = [
    'Name',
    'Created On',
    'Plan Set',
    'Updated On',
    'Number of Versions'
  ];

  const rows = useMemo(() => {
    return data.map((node, i) => (
      <PlanTableRow.FC
        key={i}
        {...node}
      />
    ));
  }, [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />
  );
};
